import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SearchStart({ inputRef, searchText, onQueryChange, onSearch, onSuggestion, suggestions, hasSearched, buttonLabel, isRTL }) {
  const { t } = useTranslation('sourcing');
  return (
        <div className="search-section">
          <h1 className="tse-title">{t('search.title', 'Instant matches, for any role.')}</h1>
          <p className="tse-subtitle">{t('search.subtitle', 'Type your job description, and get a ranked list of best fit candidates in seconds.')}</p>
          {hasSearched && <p role="status">{t('search.noResults', 'No results found')}</p>}
          <div className="search-box-card search-box-card-starter">
            <textarea
              ref={inputRef}
              className="search-box-input search-box search-box-starter"
              placeholder={t('search.placeholder', 'Paste a full job description for best results. Alternatively, list the skills & requirements you\'re looking for.')}
              value={searchText}
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <div className="search-box-footer">
              <div className="search-box-footer-left"></div>
              <button className="search-button" onClick={onSearch}>
                {buttonLabel && <span className="button-text">{buttonLabel}</span>}
                <i className={`fa-solid ${isRTL ? 'fa-arrow-left' : 'fa-arrow-right'}`}></i>
              </button>
            </div>
          </div>
          <div className="suggestions">
            {suggestions.map((suggestion, index) => (
              <button
                key={index}
                className="suggestion-button"
                onClick={() => onSuggestion(suggestion.label)}
              >
                {suggestion.label}
              </button>
            ))}
          </div>
        </div>
  );
}
